import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectionDirective } from './projection.directive';
import { ProjectionComponent } from './projection.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ProjectionDirective, ProjectionComponent],
  exports: [ProjectionDirective, ProjectionComponent],
})
export class ProjectionModule {}
